export const AdminPermissions = {
    ViewServerLogs: 'VIEW_SERVER_LOGS',
    ExportData: 'CAN_EXPORT_DATA',
    ViewCars: 'CAN_VIEW_CARS',
    ViewMap: 'CAN_VIEW_MAP',
    ViewOrders: 'CAN_VIEW_ORDERS',
    ViewPos: 'CAN_VIEW_POS',
    ViewVouchers: 'CAN_VIEW_VOUCHERS',
    ViewAirportCars: 'CAN_VIEW_AIRPORT_CARS',
    ViewUsers: 'CAN_VIEW_USERS',
    UpdateCar: 'CAN_UPDATE_CAR',
    UnpairCarDevice: 'CAN_UNPAIR_CAR_DEVICE',
    SuspendCar: 'CAN_SUSPEND_CAR',
    UnsuspendCar: 'CAN_UNSUSPEND_CAR',
    UpdatePos: 'CAN_UPDATE_POS',
    ResetPosPairing: 'CAN_RESET_POS_PAIRING',
    PayVoucher: 'CAN_PAY_VOUCHER',
    DeletePendingVouchers: 'CAN_DELETE_PENDING_VOUCHERS',
    SendCarMessage: 'CAN_SEND_CAR_MESSAGE',
    BroadcastDriverMessage: 'CAN_BROADCAST_DRIVER_MESSAGE',
    ViewKioskLogs: 'CAN_VIEW_KIOSK_LOGS',
    RestartKiosk: 'CAN_RESTART_KIOSK',
    EditUsers: 'CAN_EDIT_USERS',
    DeleteUser: 'CAN_DELETE_USER',
    ResetPassword: 'CAN_RESET_PASSWORD'
} as const;

export type AdminPermission = typeof AdminPermissions[keyof typeof AdminPermissions];
